/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonSerie,
    JsonSerieFromJSON,
    JsonSerieFromJSONTyped,
    JsonSerieToJSON,
} from './JsonSerie';

/**
 * 
 * @export
 * @interface ApiResultOfJsonSerie
 */
export interface ApiResultOfJsonSerie {
    /**
     * 
     * @type {JsonSerie}
     * @memberof ApiResultOfJsonSerie
     */
    data?: JsonSerie;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerie
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonSerie
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerie
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerie
     */
    result?: ApiResultOfJsonSerieResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonSerieResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonSerieFromJSON(json: any): ApiResultOfJsonSerie {
    return ApiResultOfJsonSerieFromJSONTyped(json, false);
}

export function ApiResultOfJsonSerieFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonSerie {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonSerieFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonSerieToJSON(value?: ApiResultOfJsonSerie | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonSerieToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

